import { twMerge } from 'tailwind-merge'

import type { MarkdownProps } from './index'

/**
 * The attributes `markdown-content.css` keys off, in one place so the read-only root, the prose
 * container and the editor's own element cannot drift. `data-measure` is absent rather than
 * `false`, because Tiptap writes whatever it is given onto the element. `select-text` because the
 * Electron renderer disables selection on `body`, and read-only markdown is still text to copy.
 */
export function markdownRootProps({
  size = 'md',
  ladder = 'document',
  measure = false,
  className,
}: Pick<MarkdownProps, 'size' | 'ladder' | 'measure' | 'className'>) {
  return {
    'data-slot': 'markdown',
    'data-size': size,
    'data-ladder': ladder,
    ...(measure ? { 'data-measure': 'true' } : {}),
    className: twMerge('markdown select-text', className),
  }
}
